enum SortDirection {
  //这两个是后台通用的标准
  ASC = 'ASC',
  DESC = 'DESC',

  //这两项是antd的标准
  DESCEND = 'descend',
  ASCEND = 'ascend'
}


export default SortDirection
